import React, {useState} from 'react';

import {translate} from 'iss/strings';
import {modifyNotification, removeNotification, systemStatusNotifications} from 'iss/service/SystemStatusNotificationService';
import styles from 'iss/styles/SystemStatusNotifications.styl';
import subscribeTo from 'iss/utils/subscriptionUtils';
import {Button, CancelButton, RemoveButton, SubmitButton} from 'iss/widgets/Buttons';
import {translateSubsystemType, translateSystemStatus} from 'iss/widgets/domainTranslations';
import {FormWithState, Input} from 'iss/widgets/Forms';
import {RestResultMessage} from 'iss/widgets/MessageBox';
import {Panel} from 'iss/widgets/Panels';
import {GlyphIcon} from 'iss/widgets/bootstrap/GlyphIcon';
import validators from 'iss/widgets/form/validation/validators';

function SystemStatusNotifications({notifications, reloadSubscription}) {
  const subsystems = getSubsystems(notifications);
  return <>
    <h1>{translate('systemStatusNotifications.title')}</h1>
    <SubsystemStatus subsystem="ALL_SYSTEMS" notification={notifications.ALL_SYSTEMS} onModified={reloadSubscription} />
    <SubsystemStatus subsystem="GENERAL_NOTIFICATION" notification={notifications.GENERAL_NOTIFICATION} onModified={reloadSubscription} />
    <SubsystemStatus subsystem="GENERAL_INTERNAL_NOTIFICATION" notification={notifications.GENERAL_INTERNAL_NOTIFICATION} onModified={reloadSubscription} />
    <SubsystemStatus subsystem="GENERAL_EXTERNAL_NOTIFICATION" notification={notifications.GENERAL_EXTERNAL_NOTIFICATION} onModified={reloadSubscription} />
    <p><strong>{translate('systemStatusNotifications.otherSystems')}</strong></p>
    {subsystems.filter(s => isOtherSubsystem(s)).map(subsystem =>
      <SubsystemStatus key={subsystem} subsystem={subsystem} notification={notifications[subsystem]} onModified={reloadSubscription} />)}
  </>;
}

function isOtherSubsystem(s) {
  return !['ALL_SYSTEMS', 'GENERAL_NOTIFICATION', 'GENERAL_INTERNAL_NOTIFICATION', 'GENERAL_EXTERNAL_NOTIFICATION'].includes(s);
}

function getSubsystems(notifications) {
  const subsystems = Object.getOwnPropertyNames(notifications);
  subsystems.sort((a,b) => {
    return translateSubsystemType(a).localeCompare(translateSubsystemType(b));
  });

  return subsystems;
}

function SubsystemStatus({subsystem, notification, onModified}) {
  const isIgnored = ['ECOM'];

  if (isIgnored.includes(subsystem)) {
    return null;
  }

  const isOk = notification.status == 'UP';
  const statusClass = isOk ? styles.ok : styles.down;

  return <Panel id={"subsystem-"+subsystem} className={styles.status+" "+statusClass} panelType={isOk ? 'default' : 'danger'}>
    <h2>
      <GlyphIcon icon={isOk ? 'ok' : 'exclamation-sign'} />{' '}
      {translateSubsystemType(subsystem)}
    </h2>
    <p>
      {translateSystemStatus(notification.status)}
      {notification.description && ": "+notification.description}
    </p>
    <NotificationEditor subsystem={subsystem} notification={notification} onModified={onModified} />
  </Panel>;
}

function NotificationEditor({subsystem, notification, onModified}) {
	const [showForm, setShowForm] = useState(false);
	const [error, setError] = useState();
	const isEmpty = notification.description === '';
  const isGeneral = ['GENERAL_NOTIFICATION', 'GENERAL_INTERNAL_NOTIFICATION', 'GENERAL_EXTERNAL_NOTIFICATION'].includes(subsystem);

	const onSave = () => { onModified(); setShowForm(false); };
	function onSubmit({description}) {
		modifyNotification(subsystem, {
			description,
			status: isGeneral ? 'UP' : 'DOWN'
		}).subscribe(onSave, setError);
  }

  function getTranslateStringFor(isGeneral, descriptionIsEmpty) {
    if (descriptionIsEmpty) {
      return isGeneral ? 'systemStatusNotifications.addGeneralNotification' : 'systemStatusNotifications.addNotification';
    } else {
      return isGeneral ? 'systemStatusNotifications.editGeneralNotification' : 'systemStatusNotifications.editNotification';
    }
  }

	return <>
		{showForm
				? <ModifyNotificationForm notification={notification} isGeneral={isGeneral} onSubmit={onSubmit} onCancel={() => setShowForm(false)} />
          : <Button className="edit" type="primary" onClick={() => setShowForm(true)}>
          {translate(getTranslateStringFor(isGeneral, isEmpty))}
          </Button>
    }
    {(isEmpty || showForm) ||
      <RemoveButton
          text={translate(isGeneral ? 'systemStatusNotifications.removeGeneralNotification'
                                    : 'systemStatusNotifications.removeNotification')}
          onClick={() => removeNotification(subsystem).subscribe(onSave, setError)} />
		}
		<RestResultMessage id="backend-error" result={error} />
	</>;
}

function ModifyNotificationForm({notification, isGeneral, onSubmit, onCancel}) {
  const notificationLabel = isGeneral ? 'systemStatusNotifications.newGeneralDescription' : 'systemStatusNotifications.newDescription';
	return <FormWithState initialValues={notification} onSubmit={onSubmit} >
		<fieldset>
			<Input id="description" valuePath="description" label={notificationLabel} validate={validators.required} maxLength="60" showCounter={true} />
			<SubmitButton text={translate('common.save')} />
			<CancelButton onClick={onCancel} />
		</fieldset>
	</FormWithState>;
}

export default subscribeTo(systemStatusNotifications, 'notifications', SystemStatusNotifications);



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/SystemStatusNotifications.jsx